import loadable from '@loadable/component';
import { SearchCardInformationHierarchyExperimentValues } from '../../../types/Experiments';

export { DiscoverHorizontalEventCardProps } from './types';
export const HORIZONTAL_EXPERIMENT_CARD_MAP = {
    [SearchCardInformationHierarchyExperimentValues.control]: loadable(
        () => import('./DiscoverHorizontalEventCard'),
    ),
    [SearchCardInformationHierarchyExperimentValues.variant1]: loadable(
        () => import('./DiscoverHorizontalEventCardVariantOne'),
    ),
    [SearchCardInformationHierarchyExperimentValues.variant2]: loadable(
        () => import('./DiscoverHorizontalEventCardVariantTwo'),
    ),
    [SearchCardInformationHierarchyExperimentValues.variant3]: loadable(
        () => import('./DiscoverHorizontalEventCardVariantThree'),
    ),
    [SearchCardInformationHierarchyExperimentValues.variant4]: loadable(
        () => import('./DiscoverHorizontalEventCardVariantFour'),
    ),
    [SearchCardInformationHierarchyExperimentValues.variant5]: loadable(
        () => import('./DiscoverHorizontalEventCardVariantFive'),
    ),
    [SearchCardInformationHierarchyExperimentValues.variant6]: loadable(
        () => import('./DiscoverHorizontalEventCardVariantSix'),
    ),
};
